import StandardReportLayout from './components/StandardReports';
import CustomReportLayout from './components/CustomReports';

export default {
    StandardReportLayout,
    CustomReportLayout
}